import {
    avatar, status,
} from './styles/QueueAvatarView'
import {DotCellStates} from 'components/Table/cellComponents'
import LetterAvatar from '../LetterAvatar'
import {NinchatQueueIcon} from 'components/Icon'
import {QueueAvatarViewProps} from './types'
import React from 'react'
import {isPropsObjectEqual} from 'utils/props'
import {styled} from 'stitches/config'

const StyledAvatar = styled('div', avatar)
const StyledIcon = styled('div', {
    color: '$queueIcon',
    variants: {
        closed: {true: {opacity: '0.5'}},
        highlight: {true: {color: '$highlight'}},
    },
})
const StyledStatus = styled('div', status)

const QueueAvatarView = (props: QueueAvatarViewProps): React.ReactElement => {
    const {
        size,
        showLetterAvatar,
        letterHighlight,
        letterLength,
        letterName,
        iconClosed,
        iconHighlight,
        statusState,
        isGroupQueue,
        groupQueues,
    } = props

    return (
        <StyledAvatar size={size}>
            {!showLetterAvatar && (
                <StyledIcon closed={iconClosed} highlight={iconHighlight}>
                    <NinchatQueueIcon />
                </StyledIcon>
            )}

            {showLetterAvatar ?
                <LetterAvatar
                    highlight={letterHighlight}
                    length={letterLength}
                    name={letterName}
                    size={size}
                />
                : null}

            <StyledStatus
                groupStatus={groupQueues?.filter((q) => !q.queueProps?.queue_attrs?.closed).length === groupQueues?.length ?
                    DotCellStates.positive :
                    groupQueues?.filter((q) => !q.queueProps?.queue_attrs?.closed).length === 0 ?
                        DotCellStates.negative
                        : DotCellStates.half}
                isGroupQueue={isGroupQueue}
                status={statusState}
            />
        </StyledAvatar>
    )
}

QueueAvatarView.defaultProps = {
    iconClosed: false,
    iconHighlight: false,
    letterHighlight: false,
    letterLength: 0,
    showLetterAvatar: false,
    size: undefined,
    statusState: undefined,
}

export default React.memo(QueueAvatarView, isPropsObjectEqual)
